import { useEffect } from "react";

const GoogleAnalytics = () => {
  useEffect(() => {
    // Load the gtag script
    const script = document.createElement("script");
    script.async = true;
    script.src = "https://www.googletagmanager.com/gtag/js?id=G-D7HQ0S96KN";
    document.head.appendChild(script);

    // Initialize gtag after script is loaded
    script.onload = () => {
      window.dataLayer = window.dataLayer || [];
      function gtag() {
        window.dataLayer.push(arguments);
      }
      gtag("js", new Date());
      gtag("config", "G-D7HQ0S96KN");
    };

    return () => {
      script.remove();
    };
  }, []);

  return null; // nothing visible on screen
};

export default GoogleAnalytics;
